import update from 'immutability-helper';
import {Map} from 'immutable';
import _ from 'lodash';
import { makeActionCreator } from 'crazyEditor/redux/helpers';
import {STATUS_FILTERS} from 'MyAccount/Listings/consts';
import {STATUS_FILTER_DRAFT} from 'MyAccount/Listings/consts';
import {REVISE_STATUS} from 'shared/globalConsts';
const SET_SELECTED_ITEM_IDS = 'listingsPage/SET_SELECTED_ITEM_IDS';
const SET_FILTER = 'listingsPage/SET_FILTER';
const SET_REVISE_STATUS = 'listingsPage/SET_REVISE_STATUS';
const SET_LISTINGS_LOAD_COMPLETED = 'listingsPage/SET_LISTINGS_LOAD_COMPLETED';
const SET_PUBLISH_IN_PROGRESS = 'listingsPage/SET_PUBLISH_IN_PROGRESS';
const TOGGLE_LEFT_MENU = 'listingsPage/TOGGLE_LEFT_MENU';
const SET_EDIT_DESCRIPTION = 'listingsPage/SET_EDIT_DESCRIPTION';
const UPDATE_LISTINGS = 'listingsPage/UPDATE_LISTINGS';
const UPDATE_LISTINGS_COUNTS = 'listingsPage/UPDATE_LISTINGS_COUNTS';
const SET_SORT_FIELD = 'listingsPage/SET_SORT_FIELD';
const TOGGLE_SORT_ASCENDING = 'listingsPage/TOGGLE_SORT_ASCENDING';
const SET_REFRESHING_FROM_EBAY = 'listingsPage/SET_REFRESHING_FROM_EBAY';
const SET_REFRESHING_FROM_EBAY_PERCENT = 'listingsPage/SET_REFRESHING_FROM_EBAY_PERCENT';
const REMOVE_DRAFT = 'listingsPage/REMOVE_DRAFT';
const SET_TEXT_BLOCKS_DATA = 'listingsPage/SET_TEXT_BLOCKS_DATA';
const UPDATE_TEXT_BLOCK_DATA = 'listingsPage/UPDATE_TEXT_BLOCK_DATA';
const APPLY_TEXT_BLOCK_DATA_CHANGES = 'listingsPage/APPLY_TEXT_BLOCK_DATA_CHANGES';
const DISCARD_TEXT_BLOCK_DATA_CHANGES = 'listingsPage/DISCARD_TEXT_BLOCK_DATA_CHANGES';
const INCREMENT_FIND_AND_REPLACE_REQUEST_INDEX = 'listingsPage/INCREMENT_FIND_AND_REPLACE_REQUEST_INDEX';
const UPDATE_TEMPLATE_S3_VERSION_ID = 'listingsPage/UPDATE_TEMPLATE_S3_VERSION_ID';
const UPDATE_SELLER_STORE = 'listingsPage/UPDATE_SELLER_STORE';

export default function reducer(state = {}, action = {}) {
  const {listings, itemIds, reviseStatus, sellerId, statusFilter, updateOnly} = action;
  switch (action.type) {
    case SET_SELECTED_ITEM_IDS:
      return {
        ...state,
        selectedItemIds: action.selectedItemIds,
      };
    case SET_FILTER:
      return {
        ...state,
        filter: action.filter,
        selectedItemIds: {},
      };
    case SET_REVISE_STATUS:
      const updateByStatusFilter = {};
      STATUS_FILTERS.forEach(statusFilter => {
        if (state.listings[sellerId][statusFilter]) {
          updateByStatusFilter[statusFilter] = {
            listings: {
              $set: state.listings[sellerId][statusFilter].listings.withMutations(updatedListings => {
                _.forEach(itemIds, itemId => {
                  if (updatedListings.has(itemId)) {
                    updatedListings.update(itemId, listing => {
                      return reviseStatus === REVISE_STATUS.ERROR && !listing.lastApiError ? ({...listing, reviseStatus, lastApiError: {action: 'Action', message: action.errorMessage || 'Unknown error'}}) : ({...listing, reviseStatus});
                    });
                  }
                });
              })
            },
          };
        }
      });
      return update(state, {
        listings: {
          [sellerId]: updateByStatusFilter,
        },
      });
    case UPDATE_LISTINGS:
      if (_.isEmpty(listings)) {
        return state;
      }
      const listingsBySellerId = _.groupBy(listings, 'sellerId');
      _.keys(listingsBySellerId).forEach(sellerId => {
        if (_.isEmpty(state.listings[sellerId])) {
          state = update(state, {
            listings: {
              [sellerId]: {
                $set: {
                  ..._.zipObject(STATUS_FILTERS, STATUS_FILTERS.map(statusFilter => ({
                    listings: new Map(),
                    listingsCount: 0,
                    listingsLoadCompleted: false,
                    listingsWithErrorsCount: 0,
                  }))),
                  fake: false,
                  refreshingFromEbayPercent: 0,
                  refreshingFromEbay: false,
                  draft: false,
                }
              }
            }
          });
        }
      });
      return update(state, {
        listings: _.mapValues(listingsBySellerId, (listings, sellerId) => {
          const sellerData = state.listings[sellerId];
          const sellerUpdate = _.mapValues(_.pick(sellerData, STATUS_FILTERS), (listingsDataForCurrentStatusFilter, statusFilter) => {
            const newListings = listingsDataForCurrentStatusFilter.listings.withMutations(updatedListings => {
              _.forEach(listings, (listing) => {
                if (updateOnly) {
                  if (updatedListings.has(listing.itemID)) {
                    updatedListings.update(listing.itemID, currentListing => ({...currentListing, ...listing}));
                  }
                } else {
                  if (statusFilter === listing.statusFilter) {
                    if (updatedListings.has(listing.itemID)) {
                      updatedListings.update(listing.itemID, currentListing => ({...currentListing, ...listing}));
                    } else {
                      updatedListings.set(listing.itemID, listing);
                    }
                  } else {
                    updatedListings.remove(listing.itemID);
                  }
                }
              });
            });
            return {
              $merge: {
                listings: newListings,
              }
            };
          });
          sellerUpdate.itemIdByDraftId = {$apply: (itemIdByDraftId) => ({...itemIdByDraftId, ..._.mapValues(_.keyBy(_.filter(listings, 'draftId'), 'draftId'), 'itemID')})};
          return sellerUpdate;
        })
      });
    case UPDATE_LISTINGS_COUNTS:
      if (!state.listings[sellerId]) {
        return state;
      }
      const {counts} = action;
      return update(state, {
        listings: {
          [sellerId]: _.mapValues(counts, count => ({
            listingsCount: {
              $set: count,
            }
          })),
        }
      });
    case SET_PUBLISH_IN_PROGRESS:
      return update(state, {
        publishInProgress: {
          $set: action.progressStatus
        },
      });
    case SET_LISTINGS_LOAD_COMPLETED:
      return update(state, {
        listings: {
          [sellerId]: {
            [statusFilter]: {
              $merge: {
                listingsLoadCompleted: true,
              }
            }
          }
        }
      });
    case TOGGLE_LEFT_MENU:
      return {
        ...state,
        leftMenuOpen: !state.leftMenuOpen
      };
    case SET_EDIT_DESCRIPTION:
      return {
        ...state,
        editDescription: action.editDescription
      };
    case SET_SORT_FIELD:
      return {
        ...state,
        sortField: action.sortField,
      };
    case TOGGLE_SORT_ASCENDING:
      return {
        ...state,
        sortAscending: !state.sortAscending,
      };
    case SET_REFRESHING_FROM_EBAY:
      return update(state, {
        listings: {
          [action.sellerId]: {
            refreshingFromEbay: {
              $set: action.refreshingFromEbay,
            },
            refreshingFromEbayPercent: {
              $set: 0,
            },
            key: {
              $apply: (key = 0) => action.aborted ? key + 1 : key,
            }
          },
        },
      });
    case SET_REFRESHING_FROM_EBAY_PERCENT:
      return update(state, {
        listings: {
          [action.sellerId]: {
            refreshingFromEbayPercent: {
              $set: action.percent,
            }
          },
        },
      });
    case REMOVE_DRAFT:
      return update(state, {
        listings: {
          [sellerId]: {
            [STATUS_FILTER_DRAFT]: {
              listings: {
                $apply: (listings) => listings.withMutations(listings => _.forEach(_.isArray(itemIds) ? itemIds : [itemIds], itemId => listings.remove(itemId))),
              }
            }
          }
        }
      });
    case SET_TEXT_BLOCKS_DATA:
      return update(state, {
        listings: {
          [sellerId]: {
            textBlocksData: {
              $set: action.textBlocksData,
            }
          }
        }
      });
    case UPDATE_TEXT_BLOCK_DATA:
      return update(state, {
        listings: {
          [sellerId]: {
            textBlocksData: {
              [action.hash]: {
                $merge: action.update,
              }
            }
          }
        }
      });
    case APPLY_TEXT_BLOCK_DATA_CHANGES:
      return update(state, {
        listings: {
          [sellerId]: {
            textBlocksData: {
              $apply: textBlocksData => _.mapValues(textBlocksData, textBlockData => ({...textBlockData, appliedStatus: textBlockData.pendingStatus})),
            }
          }
        }
      });
    case DISCARD_TEXT_BLOCK_DATA_CHANGES:
      return update(state, {
        listings: {
          [sellerId]: {
            textBlocksData: {
              $apply: textBlocksData => _.mapValues(textBlocksData, textBlockData => ({...textBlockData, pendingStatus: textBlockData.appliedStatus})),
            }
          }
        }
      });
    case INCREMENT_FIND_AND_REPLACE_REQUEST_INDEX:
      return update(state, {
        findAndReplaceRequestIndex: {$apply: findAndReplaceRequestIndex => findAndReplaceRequestIndex + 1}
      });
    case UPDATE_TEMPLATE_S3_VERSION_ID:
      const {payload: {s3VersionId, templateId}} = action;
      return update(state, {
        updatedTemplateS3VersionId: {
          [templateId]: {
            $set: s3VersionId,
          }
        }
      });
    case UPDATE_SELLER_STORE:
      const {sellerStoreCategories} = action;
      return update(state, {
        listings: {
          [sellerId]: {
            sellerStoreCategories: {
              $set: sellerStoreCategories,
            }
          }
        }
      });
    default:
      return state;
  }
}

export function setSelectedItemIds(selectedItemIds) {
  return {type: SET_SELECTED_ITEM_IDS, selectedItemIds};
}

export function setFilter(filter) {
  return {type: SET_FILTER, filter};
}

export function setReviseStatus(sellerId, itemIds, reviseStatus, errorMessage = undefined) {
  return {type: SET_REVISE_STATUS, sellerId, itemIds, reviseStatus, errorMessage};
}


export function toggleLeftMenu() {
  return {type: TOGGLE_LEFT_MENU};
}

export const setEditDescription = makeActionCreator(SET_EDIT_DESCRIPTION, 'editDescription');
export const updateListings = makeActionCreator(UPDATE_LISTINGS, 'listings', 'updateOnly');
export const updateListingsCounts = makeActionCreator(UPDATE_LISTINGS_COUNTS, 'sellerId', 'counts');
export const setSortField = makeActionCreator(SET_SORT_FIELD, 'sortField');
export const toggleSortAscending = makeActionCreator(TOGGLE_SORT_ASCENDING);
export const setRefreshingFromEbay = makeActionCreator(SET_REFRESHING_FROM_EBAY, 'refreshingFromEbay', 'sellerId', 'aborted');
export const setRefreshingFromEbayPercent = makeActionCreator(SET_REFRESHING_FROM_EBAY_PERCENT, 'percent', 'sellerId');
export const setPublishInProgress = makeActionCreator(SET_PUBLISH_IN_PROGRESS, 'progressStatus');
export const setListingsLoadCompleted = makeActionCreator(SET_LISTINGS_LOAD_COMPLETED, 'sellerId', 'statusFilter');
export const removeDraft = makeActionCreator(REMOVE_DRAFT, 'sellerId', 'itemIds');
export const setTextBlocksData = makeActionCreator(SET_TEXT_BLOCKS_DATA, 'sellerId', 'textBlocksData');
export const updateTextBlockData = makeActionCreator(UPDATE_TEXT_BLOCK_DATA, 'sellerId', 'hash', 'update');
export const applyTextBlockDataChanges = makeActionCreator(APPLY_TEXT_BLOCK_DATA_CHANGES, 'sellerId');
export const discardTextBlockDataChanges = makeActionCreator(DISCARD_TEXT_BLOCK_DATA_CHANGES, 'sellerId');
export const incrementFindAndReplaceRequestIndex = makeActionCreator(INCREMENT_FIND_AND_REPLACE_REQUEST_INDEX);
export const updateTemplateS3VersionId = makeActionCreator(UPDATE_TEMPLATE_S3_VERSION_ID, 'payload');
export const updateSellerStoreCategories = makeActionCreator(UPDATE_SELLER_STORE, 'sellerId', 'sellerStoreCategories');
